import React from "react";

import "../styles/GlobalHeader.css";

const GlobalHeader = () => {
	return (
		<div className="pi-shared-nav-wrapper">
			<div
				className="pi-shared-nav-header-site pi-shared-nav-header-site-insights"
				data-metrics-location="HDR"
			>
				<nav aria-label="Secondary" role="navigation">
					<div className="pi-shared-nav-navbar  pi-shared-nav-navbar-default">
						<div className="pi-shared-nav-navbar-inner">
							{/* <div className="pi-shared-nav-menu-trigger ">
								<i className="pi-shared-nav-fa pi-shared-nav-fa-bars"></i>
							</div> */}
							<div className="pi-shared-nav-navbar-header-icon ">
								<a
									href="https://www.troweprice.com/"
									className="pi-shared-nav-navbar-brand"
								>
									<img
										src="https://www.troweprice.com/content/dam/trowecorp/wordmark/wordmark-global.png"
										alt="T. Rowe Price"
										width="148px"
										height="22px"
									></img>
								</a>
							</div>

							<ul
								id="pi-shared-nav-ut-nav"
								className="pi-shared-nav-navbar-nav pi-shared-nav-nav-trp-header pi-shared-nav-nav-trp-header-icon pi-shared-nav-list-inline"
							>
								<li className="pi-shared-nav-trp-logo">
									<img
										src="https://www.troweprice.com/etc/designs/trowecorp/clientlibs/global/css/images/TRP-logo-V2.png"
										height="45px"
										width="45px"
										alt="T. Rowe Price"
									></img>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		</div>
	);
};

export default GlobalHeader;
